import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/research/src/components/layout.js";
import Anatomy from '../components/anatomy';
import Concepts from '../components/concepts';
import ComponentCoverage from '../components/component-coverage';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentCoverage component="Slider" mdxType="ComponentCoverage" />
    <h2>{`Anatomy`}</h2>
    <Anatomy component="Slider" mdxType="Anatomy" />
    <h2>{`Concepts`}</h2>
    <Concepts component="Slider" mdxType="Concepts" />
    <h2>{`Additional research`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/slider.research.parts"
        }}>{`Parts & Part Concepts`}</a></li>
    </ul>
    <h2>{`Notes`}</h2>
    <p>{`While not called out explicitly, sliders usually have a min/max value.`}</p>
    <p>{`Sliders with a filled in slide indicates whether or not the values include the preceeding value. Sliders without a filled in slide indicate an individual point is selected.`}</p>
    <p>{`Snapping behavior is supported by some sliders. That's where there are only a select few steps and the slider jumps to those points rather than smoothly going between them.`}</p>
    <p>{`Most sliders support a "controlled" state where a value can be entered elsewhere and the slider will move the appropriate position that accompanies the value`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      